import {event} from '../modules/event';

var QuizForm = class {
    constructor(form) {
        this._createElements(form);
        this._addEvents();
    }

    _createElements(form){
        this.form = form;
        this.form.noValidate = true;
        this.answerAll = this.form.querySelectorAll('[data-QuizForm-answer]');
    }

    _addEvents(){
        var self = this;

        this.form.addEventListener('submit', function(e){
            if(!regAuthObj.isAuth){
                e.preventDefault();
                regAuthObj.authForm.showPopup();
            }
            else if (!e.target.checkValidity()) {
                e.preventDefault();
                uPopup({
                    content:'Пожалуйста, ответьте на все вопросы'
                });
            }
        });

        for(var i=0,j=this.answerAll.length; i<j; i++){
            event.add(this.answerAll[i], 'click', function(e){
                if(!regAuthObj.isAuth){
                    e.preventDefault();
                    regAuthObj.authForm.showPopup();
                }
            });
        }
    }
}

export {QuizForm};






































